import { render, staticRenderFns } from "./AllPage.vue?vue&type=template&id=40c847fe&"
import script from "./AllPage.vue?vue&type=script&lang=js&"
export * from "./AllPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/AllPage.vue"
export default component.exports